import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/huyenpvd/domains/caocaoadventures/caocaoadventures_v2/src/components/page-render.tsx");
